import {Component, OnDestroy} from '@angular/core';
import {fromEvent, merge, Subscription} from 'rxjs';
import {map} from 'rxjs/operators';
import {DeprecatedSharedUtilsModule} from '../../deprecated-shared-utils-module';
import {SweetAlertOptions} from 'sweetalert2';
import UiSwal from '../../ui/misc/ui-swal';

declare var $: any;

@Component({
    selector: 'detecting-connection',
    template: '',
    imports: [
        DeprecatedSharedUtilsModule,
    ]
})
export class DetectingConnectionComponent implements OnDestroy {
    private readonly isNetworkOnline: Subscription

    alert: any;

    constructor() {
        const onlineEvent = fromEvent(window, 'online').pipe(map(() => true));
        const offlineEvent = fromEvent(window, 'offline').pipe(map(() => false));

        this.isNetworkOnline = merge(onlineEvent, offlineEvent)
            .subscribe((isConnected: boolean) => {
                if (isConnected) {
                    this.alert ? this.alert.close() : '';
                } else {
                    this.alert = UiSwal.fire({
                        type: 'warning',
                        title: 'Sem Conexão de Internet',
                        html: 'Verifique sua conexão.<br> O sistema irá detectar a volta da internet e voltará a funcionar automaticamente.',
                        showConfirmButton: false
                    } as SweetAlertOptions);
                }
                $("body").css({"pointer-events": isConnected ? "all" : "none"});
            });
    }

    ngOnDestroy(): void {
        this.isNetworkOnline.unsubscribe()
    }
}
